export default {
	name	: 'MainTextarea',
	props	: {
		value		: String,
		label		: String,
		placeholder	: String,
		disabled	: Boolean,
		required	: Boolean,
		maxlength	: Number,
		rows		: {
			type		: Number,
			default		: 4
		},
		errorMessage: String
	}
}
